import React, { useState, useEffect } from "react";
import api from "@api";

export function useApproverDistroSelect(
  approverDistro?: any,
  approverDistro2?: any,
  approverDistro3?: any,
  approverDistro4?: any
) {
  // approver distro can be call/use for single usage of approver distro
  const [selectedApproverDistro, setSelectedApproverDistro] = React.useState<
    any
  >(0);
  const [selectedApproverDistro2, setSelectedApproverDistro2] = React.useState<
    any
  >(0);
  const [selectedApproverDistro3, setSelectedApproverDistro3] = React.useState<
    any
  >(0);
  const [selectedApproverDistro4, setSelectedApproverDistro4] = React.useState<
    any
  >(0);
  const [approverDistros, setApproverDistros] = useState([]);
  const [isFetchingApproverDistros, setFetchingApproverDistro] = useState(
    false
  );

  useEffect(() => {
    setFetchingApproverDistro(true);
    api.approver
      .getApproverDistro()
      .then((response) => {
        let responseData: any = [];
        console.log(response);
        response.mappvrDistro.forEach((d: any) => {
          responseData = [
            ...responseData,
            {
              label: d.name,
              value: d.id,
            },
          ];
        });

        responseData = responseData.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        );

        responseData = [
          {
            label: "No selection",
            value: 0,
          },
          ...responseData,
        ];
        setApproverDistros(responseData);
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        setFetchingApproverDistro(false);
      });
  }, []);

  useEffect(() => {
    if (approverDistros.length !== 0) {
      if (approverDistro) setSelectedApproverDistro(approverDistro);
      if (approverDistro2) setSelectedApproverDistro2(approverDistro2);
      if (approverDistro3) setSelectedApproverDistro3(approverDistro3);
      if (approverDistro4) setSelectedApproverDistro4(approverDistro4);
    }
    return () => {
      setSelectedApproverDistro(0);
      setSelectedApproverDistro2(0);
      setSelectedApproverDistro3(0);
      setSelectedApproverDistro4(0);
    };
  }, [approverDistros]);

  const handleApproverDistroTypeChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === "approverDistro") setSelectedApproverDistro(value);
    if (name === "approverDistro2") setSelectedApproverDistro2(value);
    if (name === "approverDistro3") setSelectedApproverDistro3(value);
    if (name === "approverDistro4") setSelectedApproverDistro4(value);
  };

  return {
    approverDistros,
    isFetchingApproverDistros,
    selectedApproverDistro,
    selectedApproverDistro2,
    selectedApproverDistro3,
    selectedApproverDistro4,
    setSelectedApproverDistro,
    setSelectedApproverDistro2,
    setSelectedApproverDistro3,
    setSelectedApproverDistro4,
    handleApproverDistroTypeChange,
  };
}
